export default __webpack_public_path__ + "static/media/travel-bag-3x.6496840e.webp";